
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import store from "../../store/index";
export default {
  name: "AactStudyRbqmComparisonDashboard",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    const performanceRaw = {
  "SAE Rate": {
    aactBaseline: 1,
    currentStudy: 0,
  },
  "Major Protocol Deviation Rate": {
    aactBaseline: 3,
    currentStudy: 0,
  },
  "Enrollment Rate": {
    aactBaseline: 145,
    currentStudy: 18,
  },
  "Geographic Spread": {
    aactBaseline: 25,
    currentStudy: 0,
  },
};
    const aactData = {
      riskByPhaseCondition: {
        phases: ["Phase 1", "Phase 2", "Phase 3", "Phase 4"],
        conditions: [
          "Plaque Psoriasis",
          "Generalized Pustular Psoriasis",
          "Psoriatic Arthritis",
        ],
        z: [
          [40, 55, 65, 50],
          [45, 60, 70, 55],
          [38, 52, 63, 48],
        ],
      },
      performanceBaseline: {
        metrics: [
          "Screen Failure Rate (%)",
          "Serious AE Rate (%)",
          "Protocol Deviations (%)",
        ],
        values: [24.5, 90.9, 12.0,],
      },
      protocolComplexity: {
        labels: [
          "Eligibility Criteria",
          "Intervention Arms",
          "Endpoints",
          "Geographic Spread",
          "Other",
        ],
        values: [30, 20, 25, 15, 10],
      },
      siteBenchmarks: {
        enrollmentRate: 75,
        dataQuality: 90,
        protocolCompliance: 88,
      },
      qtlBreaches: {
        years: [2023, 2024, 2025],
        screenFailureBreach: [1, 3, 6],
        dropoutBreach: [0, 1, 2],
        aeBreach: [0, 0, 1],
      },
    };

    const studyData = {
      name: "H2Q-MC-LZZT",
      riskScore: 422.87,
      riskLevel: "Moderate",
      riskLevelClass: "risk-medium",
      avgEnrollmentPlanned: 160,
      completionRate: 82.0,
      performanceCurrent: {
        metrics: [
          "Screen Failure Rate (%)",
          "Completion Rate (%)",
          "Serious AE Rate (%)",
          "Protocol Deviations (%)",
          "Data Queries / subj",
        ],
        values: [28.0, 82.0, 15.0,],
      },
      protocolComplexity: {
        labels: [
          "Eligibility Criteria",
          "Intervention Arms",
          "Endpoints",
          "Geographic Spread",
          "Other",
        ],
        values: [35, 25, 20, 15, 5],
      },
      sites: {
        names: ["Site 200", "Site 201", "Site 202", "Site 203"],
        enrollmentRate: [82, 60, 45, 90],
        dataQuality: [96, 88, 78, 92],
        protocolCompliance: [94, 80, 70, 98],
      },
      qtlBreaches: {
        years: [2023, 2024, 2025],
        screenFailureBreach: [0, 1, 2],
        dropoutBreach: [0, 0, 1],
        aeBreach: [0, 0, 0],
      },
      riskSignals: [
        {
          name: "Query aging (critical DP)",
          observedMetric: "132 days",
          benchmark: "≤ 60 days (norm)",
          position: "Above 90th percentile",
          level: "High",
        },
        {
          name: "AE entry delay (AESTDAT)",
          observedMetric: "0.5 days",
          benchmark: "1.0 day (10th percentile)",
          position: "Better than benchmark",
          level: "Low",
        },
        {
          name: "Protocol deviations per subject",
          observedMetric: "1.1",
          benchmark: "0.8 (mean)",
          position: "Slightly higher than mean",
          level: "Medium",
        },
      ],
    };

    return {
      baseurl: process.env.VUE_APP_Service_URL,
      currentstudyname: "H2Q-MC-LZZT",
      autofilldata:[],
      showSuggestions: false,
      selectedStudy: "",
      therapeuticArea: "Alzheimer's",
      studyPhase: "PHASE2",
      timeRange: "5",
      riskThreshold: 70,
      srtudylist:[],
      kpiAACTSimilarTrials: 54,
      kpiAACTAvgEnrollment: 132,
      aactData,
      studyData,
      horizondalperformanceSeries: [],
    horizondalperformanceOptions: {
      chart: { type: "bar", toolbar: { show: false } },
      plotOptions: { bar: { horizontal: true, barHeight: "55%" } },
      dataLabels: { enabled: false },
      xaxis: { categories: [] },
      legend: { position: "bottom" },
      tooltip: { shared: true, intersect: false },
    },
      complexityAACTSeries: [],
      complexityAACTOptions: {},
      complexityStudySeries: [],
      complexityStudyOptions: {},
      sitePerformanceSeries: [],
      sitePerformanceOptions: {
  chart: { type: "bar", toolbar: { show: false } },
  plotOptions: { bar: { horizontal: false, columnWidth: "45%" } },
  dataLabels: { enabled: false },
  grid: {
    xaxis: { lines: { show: false } },
    yaxis: { lines: { show: false } },
  },
  stroke: { show: true, width: 1, colors: ["transparent"] },
  xaxis: { categories: [], title: { text: "Sites" } },
  yaxis: { min: 0, max: 100, title: { text: "Percentage" } },
  legend: { position: "bottom" },
  annotations: { yaxis: [] },
  tooltip: {
    y: {
      formatter: function (val) {
        if (val === null || val === undefined) return "-";
        var n = Number(val);
        return isFinite(n) ? n.toFixed(2) + "%" : "-";
      },
    },
  },
},
       qtlSeries: [],
    qtlOptions: {
      chart: { type: "line", toolbar: { show: false } },
      stroke: { width: 2, curve: "smooth", dashArray: [0, 0, 0, 4, 4, 4] },
      markers: { size: 4 },
      dataLabels: { enabled: false },
      xaxis: { categories: [], title: { text: "Year" } },
      yaxis: { title: { text: "No. of Breaches" }, min: 0 },
      legend: { position: "bottom" },
    },
    totalstudyforenrollments:0,
    enrollmentsSeries: [],
    enrollmentsOptions: {
      chart: { type: "bar", toolbar: { show: false } },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          borderRadius: 4,
        },
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 1, colors: ["transparent"] },
      xaxis: {
        categories: [],
        labels: { rotate: -15, trim: false },
      },
      yaxis: {
        min: 0,
        title: { text: "Enrollments per month" },
      },
      tooltip: {
        y: {
          formatter: (val) => (val == null ? "" : Number(val).toFixed(2)),
        },
      },
      legend: { position: "bottom" },
    },
      loadingsiteenrollmentrate: false,
    totalstudyforsiteenrollments:0,
    siteenrollmentsSeries: [],
    siteenrollmentsOptions: {
      chart: {
        type: "bar",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
        },
      },
      dataLabels: { enabled: false },
      stroke: { show: false },
      xaxis: {
        categories: [],
        labels: {
          rotate: -35,
          trim: true,
        },
      },
      yaxis: {
        title: { text: "Enrollment / Month" },
        min: 0,
      },
      tooltip: {
        y: {
          formatter: (val) => (val == null || isNaN(val) ? "" : Number(val).toFixed(2)),
        },
      },
      legend: { show: false },
      annotations: {
        yaxis: [], // we’ll fill this dynamically
      },
      noData: { text: "No enrollment data" },
    },
    loadingenrollmentsPerf: false,
      loadingPerformance: false,
       sitePerformanceLoading: false,
       loadingHorizontalPerf: false,
       loadingQtl: false,
       completedstudycount: 0,
      totalstudycount: 0,
      terminatedstudycount: 0,
      withdrawnstudycount: 0,
    };
  },
  computed: {
  hasHorizontalPerfData() {
    const cats = this.horizondalperformanceOptions?.xaxis?.categories || [];
    return Array.isArray(cats) && cats.length > 0 && Array.isArray(this.horizondalperformanceSeries) && this.horizondalperformanceSeries.length > 0;
  },
},
  created() {
    this.initializeCharts();
  },
  mounted(){
     window.addEventListener("studyIdChanged", async () => {
       const currentstudy = store.getters.getStudyIs;
      this.selectedStudy = currentstudy;
       let studyobj = this.srtudylist.find((eachstudy)=> eachstudy.studyId == this.selectedStudy ) 
       this.getallstudy();
       this.updateDashboard();
    });
  },
  watch: {
    selectedStudy: {
      deep: true,
      handler() {
         let studyobj = this.srtudylist.find((eachstudy)=> eachstudy.studyId == this.selectedStudy ) 
       this.currentstudyname = studyobj.studyRef;
      },
    },
  },
  methods: {
    initializeCharts() {
      this.getallstudy();
      this.getstudymetrics();
      this.buildPerformanceBenchmark();
      this.buildHorizontalPerformanceChart();
      this.buildComplexityCharts();
      this.buildSitePerformance();
      this.getEnrollmentsComparison();
      this.buildSiteEnrollmentRateBar();
    },
    updateDashboard() {
      this.getstudymetrics();
      this.buildPerformanceBenchmark();
      this.buildHorizontalPerformanceChart();
      this.buildComplexityCharts();
      this.buildSitePerformance();
      this.getEnrollmentsComparison();
      this.buildSiteEnrollmentRateBar();
    },
    async buildSiteEnrollmentRateBar() {
  this.loadingsiteenrollmentrate = true;
   this.totalstudyforsiteenrollments = 0;
  try {
    const res = await axios.get(
      this.baseurl + "/aact-connection-py/aact/getsiteenrollment",
      {
        params: {
          therapeutic_area: (this.therapeuticArea || "").trim(),
          phase: (this.studyPhase || "").trim(),
          years_back: this.timeRange,
          study_id: this.selectedStudy,
        },
      }
    );

    const data = res?.data || {};
    if(data.aact_enrollment && data.aact_enrollment.total_studies){
    this.totalstudyforsiteenrollments = data.aact_enrollment.total_studies;
    }
    const avgRaw =
      data?.aact_enrollment?.avg_enrollment_per_month_across_all_studies;
    const avg = Number(avgRaw);
    const hasAvg = !isNaN(avg);

    const studyObj = data?.study_enrollment || {};

    // turn object -> array
    const rows = Object.keys(studyObj)
      .map((k) => studyObj[k])
      .filter((r) => r && r.siteName != null);

    // sort sites nicely (optional)
    rows.sort((a, b) => String(a.siteName).localeCompare(String(b.siteName)));

    const categories = rows.map((r) => String(r.siteName));
    const values = rows.map((r) => {
      const n = Number(r.studyMedian);
      return isNaN(n) ? null : n;
    });

    this.siteenrollmentsSeries = [
      {
        name: "Study Enrollment (per month)",
        data: values,
      },
    ];

    const yAnnotations = [];
    if (hasAvg) {
      yAnnotations.push({
        y: avg,
        borderColor: "#0ac019ff", // keep simple; Apex needs a color, so black works reliably
        strokeDashArray: 6,
        label: {
          borderColor: "#0ac019ff",
          style: {
            color: "#000000ff",
            background: "#0ac019ff",
          },
          text: `Avg enrollment per month: ${avg.toFixed(2)}`,
        },
      });
    }

    this.siteenrollmentsOptions = {
      ...this.siteenrollmentsOptions,
      xaxis: {
        ...(this.siteenrollmentsOptions.xaxis || {}),
        categories,
      },
      annotations: {
        ...(this.siteenrollmentsOptions.annotations || {}),
        yaxis: yAnnotations,
      },
    };
  } catch (err) {
    console.error("Site enrollment bar API error:", err);
    this.siteenrollmentsSeries = [];
    this.siteenrollmentsOptions = {
      ...this.siteenrollmentsOptions,
      xaxis: { ...(this.siteenrollmentsOptions.xaxis || {}), categories: [] },
      annotations: { ...(this.siteenrollmentsOptions.annotations || {}), yaxis: [] },
    };
  } finally {
    this.loadingsiteenrollmentrate = false;
  }
},
    async getEnrollmentsComparison() {
  this.loadingenrollmentsPerf = true;
this.totalstudyforenrollments = 0;
  try {
    const res = await axios.get(
      this.baseurl +
        "/aact-connection-py/aact/getenrollments" +
        "?therapeutic_area=" + encodeURIComponent(this.therapeuticArea) +
        "&phase=" + encodeURIComponent(this.studyPhase) +
        "&years_back=" + encodeURIComponent(this.timeRange) +
        "&study_id=" + encodeURIComponent(this.selectedStudy)
    );

    const data = (res && res.data) ? res.data : {};
    if( data.aact_enrollment && data.aact_enrollment.total_studies){
    this.totalstudyforenrollments = data.aact_enrollment.total_studies;
    }
    const aactObj = data.aact_enrollment ? data.aact_enrollment : {};

    const aactTotal = aactObj.total_studies;

    const aactAvgRaw = aactObj.avg_enrollment_per_month_across_all_studies;
    let aactAvg = parseFloat(aactAvgRaw);
    if (!isFinite(aactAvg)) aactAvg = 0;

    const metrics = Array.isArray(data.study_enrollment) ? data.study_enrollment : [];

    const categories = metrics.map(function (m) {
      return String((m && m.riskName) ? m.riskName : "Metric");
    });

    const studyValues = metrics.map(function (m) {
      const v = m && m.value;
      const n = parseFloat(v);
      return isFinite(n) ? n : 0;
    });

    const aactValues = metrics.map(function () {
      return aactAvg;
    });

    this.enrollmentsSeries = [
      {
        name: this.currentstudyname,
        data: studyValues,
      },
      {
        name: "Baseline",
        data: aactValues,
      },
    ];

    this.enrollmentsOptions = {
      ...this.enrollmentsOptions,
      xaxis: {
        ...(this.enrollmentsOptions.xaxis || {}),
        categories: categories,
      },
    };
  } catch (err) {
    console.log("getenrollments error:", err);
    this.enrollmentsSeries = [];
    this.enrollmentsOptions = {
      ...this.enrollmentsOptions,
      xaxis: { ...(this.enrollmentsOptions.xaxis || {}), categories: [] },
    };
  } finally {
    this.loadingenrollmentsPerf = false;
  }
},
    async getstudymetrics() {
       const defaultval = {
    avg_completion_rate: 0,
    avg_study_duration_months: 0,
    avg_planned_enrollment: 0,
    avg_risk_score: 0,
    total_study: 0,
    completed_study_count: 0,
    terminated_study_count: 0,
    withdrawn_study_count: 0,
    phases_included: ""
};

      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/studymetrics?therapeutic_area=${this.therapeuticArea.trim()}&phase=${this.studyPhase}&time_range_years=${this.timeRange}`
        );

        console.log("getstudymetrics result = ", res.data);

        const metrics = res.data || defaultval;
        this.completedstudycount = metrics.completed_study_count;
        this.totalstudycount = metrics.total_study;
        this.terminatedstudycount = metrics.terminated_study_count;
        this.withdrawnstudycount = metrics.withdrawn_study_count;
      } catch (err) {
        console.log("error in getstudymetrics", err);
        const metrics = defaultval;
        this.completedstudycount = metrics.completed_study_count;
        this.totalstudycount = metrics.total_study;
        this.terminatedstudycount = metrics.terminated_study_count;
        this.withdrawnstudycount = metrics.withdrawn_study_count;
      }
    },
     safeNumber(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  },

  async buildHorizontalPerformanceChart() {
  this.loadingHorizontalPerf = true;

  try {
    const res = await axios.get(
      this.baseurl + "/aact-connection-py/aact/riskfactors" +
      "?therapeutic_area=" + encodeURIComponent(this.therapeuticArea) +
      "&phase=" + encodeURIComponent(this.studyPhase) +
      "&time_range=" + encodeURIComponent(this.timeRange) +
      "&study_id=" + encodeURIComponent(this.selectedStudy)
    );

    console.log("HorizontalPerformanceChart result =", res && res.data);
    var payload = {};
    if (res && res.data && typeof res.data === "object") {
      if (res.data.risk_factors && typeof res.data.risk_factors === "object") {
        payload = res.data.risk_factors;
      } else {
        payload = res.data;
      }
    }

    var categories = Object.keys(payload || {});

    var baseline = categories.map((k) => {
      var v = payload && payload[k] ? payload[k].aactBaseline : 0;
      v = Number(v);
      return isFinite(v) ? v : 0;
    });

    var current = categories.map((k) => {
      var v = payload && payload[k] ? payload[k].currentStudy : 0;
      v = Number(v);
      return isFinite(v) ? v : 0;
    });

    this.horizondalperformanceSeries = [
      { name: this.currentstudyname, data: current },
      { name: "Baseline", data: baseline },
    ];

    this.horizondalperformanceOptions = Object.assign({}, this.horizondalperformanceOptions, {
      xaxis: Object.assign({}, this.horizondalperformanceOptions.xaxis, {
        categories: categories,
      }),
    });

  } catch (err) {
    console.error("error in HorizontalPerformanceChart", err);

    this.horizondalperformanceSeries = [];
    this.horizondalperformanceOptions = Object.assign({}, this.horizondalperformanceOptions, {
      xaxis: Object.assign({}, this.horizondalperformanceOptions.xaxis, { categories: [] }),
    });
  } finally {
    this.loadingHorizontalPerf = false;
    console.log("HorizontalPerformanceChart finished");
  }
},

async autofillFun() {
  this.autofilldata = [];
    if(this.therapeuticArea == ""){
      return
    }
      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/searchconditions?query=${this.therapeuticArea}`
        );

        console.log("autofillFun result = ", res.data);
        this.autofilldata = res.data.conditions;

      } catch (err) {
        console.log("error in autofillFun", err);

      }
    },
selectSuggestion(value) {
      this.therapeuticArea = value;
      this.showSuggestions = false;
      this.updateDashboard();
    },

    handleBlur() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 150);
    },
    async buildPerformanceBenchmark() {
  this.loadingPerformance = true;

  try {
    const res = await axios.get(
      `${this.baseurl}/aact-connection-py/aact/compareperformance` +
      `?therapeutic_area=${encodeURIComponent(this.therapeuticArea)}` +
      `&phase=${encodeURIComponent(this.studyPhase)}` +
      `&time_range_years=${encodeURIComponent(this.timeRange)}` +
      `&study_id=${encodeURIComponent(this.selectedStudy)}`
    );

    console.log("PerformanceBenchmark result = ", res.data);

    const raw = res.data || {};
    const metrics = Object.keys(raw);

    if (!metrics.length) {
      this.performanceSeries = [];
      this.performanceOptions = {
        chart: { type: "bar", toolbar: { show: false } },
        xaxis: { categories: [],
        title: { text: "Value(%)" }
         },
        yaxis: { title: { text: "Value(%)" } },
      };
      return;
    }

    const aactBaseline = [];
    const currentStudy = [];

    metrics.forEach(function (label) {
      var row = raw[label] || {};
      var baselineVal = typeof row.aactBaseline === "number" ? row.aactBaseline : 0;
      var currentVal = typeof row.currentStudy === "number" ? row.currentStudy : 0;

      aactBaseline.push(baselineVal);
      currentStudy.push(currentVal);
    });

    this.performanceSeries = [
      {
        name: this.currentstudyname,
        data: currentStudy,
      },
      {
        name: "Baseline",
        data: aactBaseline,
      },
    ];

    this.performanceOptions = {
      chart: {
        type: "bar",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: metrics,
        labels: {
          rotate: -20,
          formatter(value) {
            var str = (value === undefined || value === null) ? "" : String(value);
            return str.length > 30 ? str.slice(0, 30) + "..." : str;
          },
        },
      },
      yaxis: {
        title: { text: "Value(%)" },
      },
      legend: {
        position: "bottom",
      },
      tooltip: {
        y: {
          formatter(val) {
            return (typeof val === "number") ? val.toFixed(2) : val;
          },
        },
      },
    };
  } catch (err) {
    console.error("error in PerformanceBenchmark", err);
    this.performanceSeries = [];
  } finally {
    this.loadingPerformance = false;
  }
},
 async buildSitePerformance() {
  this.sitePerformanceLoading = true;

  var preferredKeys = ["EnrollmentRate", "DataQuality", "ProtocolCompliance"];
  var labelMap = {
    EnrollmentRate: "Enrollment Rate",
    DataQuality: "Data Quality",
    ProtocolCompliance: "Protocol Compliance",
  };
  var toNum = function (v) {
    var n = Number(v);
    return isFinite(n) ? n : null;
  };

  var prettyLabel = function (key) {
    if (labelMap[key]) return labelMap[key];
    return String(key || "")
      .replace(/_/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .trim();
  };

  var pushUnique = function (arr, val) {
    if (!val) return;
    if (arr.indexOf(val) === -1) arr.push(val);
  };

  var buildSiteNames = function (dataObj, keys) {
    var sites = [];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var list = dataObj && dataObj[k] && Array.isArray(dataObj[k].sites) ? dataObj[k].sites : [];
      for (var j = 0; j < list.length; j++) {
        pushUnique(sites, list[j] && list[j].siteName);
      }
    }
    return sites;
  };

  var makeLookup = function (list) {
    var m = {};
    for (var i = 0; i < list.length; i++) {
      var row = list[i] || {};
      if (row.siteName) m[row.siteName] = toNum(row.studyMedian);
    }
    return m;
  };

  var getPalette = function () {
    var optColors = this.sitePerformanceOptions && this.sitePerformanceOptions.colors;
    if (Array.isArray(optColors) && optColors.length) return optColors;

    return [
      "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0",
      "#546E7A", "#26A69A", "#D10CE8", "#00897B", "#F86624",
      "#2E93FA", "#66DA26", "#E91E63", "#546E7A", "#FF9800"
    ];
  };

  var pickColor = function (palette, idx) {
    return palette[idx % palette.length];
  };

  try {
    var url =
      this.baseurl +
      "/aact-connection-py/aact/siteperformancetrends" +
      "?therapeutic_area=" + encodeURIComponent(this.therapeuticArea) +
      "&phase=" + encodeURIComponent(this.studyPhase) +
      "&time_range_years=" + encodeURIComponent(this.timeRange) +
      "&study_id=" + encodeURIComponent(this.selectedStudy);

    var res = await axios.get(url);
    console.log("siteperformancetrends data",res.data);
     var d = res && res.data ? res.data : {};

    var apiKeys = Object.keys(d || {});
    var metricKeys = preferredKeys
      .filter(function (k) { return apiKeys.indexOf(k) !== -1; })
      .concat(apiKeys.filter(function (k) { return preferredKeys.indexOf(k) === -1; }));

    var visibleKeys = metricKeys.filter(function (k) {
      return d && d[k] && Array.isArray(d[k].sites) && d[k].sites.length;
    });

    if (!visibleKeys.length) {
      this.sitePerformanceSeries = [];
      this.sitePerformanceOptions = Object.assign({}, this.sitePerformanceOptions, {
        xaxis: Object.assign({}, (this.sitePerformanceOptions && this.sitePerformanceOptions.xaxis) || {}, {
          categories: [],
        }),
        annotations: { yaxis: [] },
      });
      return;
    }

    var siteNames = buildSiteNames(d, visibleKeys);

    var palette = getPalette.call(this);
    var seriesColors = [];
    for (var ci = 0; ci < visibleKeys.length; ci++) {
      seriesColors.push(pickColor(palette, ci));
    }

    var series = [];
    var maxVal = 0;

    for (var s = 0; s < visibleKeys.length; s++) {
      var key = visibleKeys[s];
      var list = d[key] && Array.isArray(d[key].sites) ? d[key].sites : [];
      var lookup = makeLookup(list);

      var dataArr = [];
      for (var x = 0; x < siteNames.length; x++) {
        var v = lookup[siteNames[x]];
        dataArr.push(v);

        if (v !== null && v !== undefined && Number(v) > maxVal) {
          maxVal = Number(v);
        }
      }

      series.push({
        name: prettyLabel(key),
        data: dataArr,
      });
    }

    var yAnn = [];

    for (var b = 0; b < visibleKeys.length; b++) {
      var k2 = visibleKeys[b];
      var med = d && d[k2] ? toNum(d[k2].aactMedian) : null;
      if (med === null) continue;

      if (med > maxVal) maxVal = med;

      var c = seriesColors[b];

      yAnn.push({
        y: med,
        strokeDashArray: 4,
        borderColor: c,
        label: {
          text: prettyLabel(k2) + " Benchmark",
          position: "right",
          borderColor: c,
          offsetX: 0,
          offsetY: -8 * b, 
          style: {
            background: c,
            color: "#fff",
            fontSize: "12px",
            padding: { left: 8, right: 8, top: 4, bottom: 4 },
          },
        },
      });
    }

    var yMax = Math.max(100, Math.ceil(maxVal * 1.1));

    this.sitePerformanceSeries = series;

    this.sitePerformanceOptions = Object.assign({}, this.sitePerformanceOptions, {
      colors: seriesColors, 
      plotOptions: Object.assign({}, this.sitePerformanceOptions.plotOptions || {}, {
        bar: Object.assign({}, (this.sitePerformanceOptions.plotOptions && this.sitePerformanceOptions.plotOptions.bar) || {}, {
          horizontal: false,
        }),
      }),
      xaxis: Object.assign({}, (this.sitePerformanceOptions && this.sitePerformanceOptions.xaxis) || {}, {
        categories: siteNames,
        title: { text: "Sites" },
      }),
      yaxis: Object.assign({}, (this.sitePerformanceOptions && this.sitePerformanceOptions.yaxis) || {}, {
        min: 0,
        max: yMax,
        title: { text: "Percentage" },
      }),
      annotations: Object.assign({}, (this.sitePerformanceOptions && this.sitePerformanceOptions.annotations) || {}, {
        yaxis: yAnn,
      }),
    });

    console.log("siteperformance data = ", d);
  } catch (err) {
    console.log("error in buildSitePerformance", err);

    this.sitePerformanceSeries = [];
    this.sitePerformanceOptions = Object.assign({}, this.sitePerformanceOptions, {
      xaxis: Object.assign({}, (this.sitePerformanceOptions && this.sitePerformanceOptions.xaxis) || {}, {
        categories: [],
      }),
      annotations: { yaxis: [] },
    });
  } finally {
    this.sitePerformanceLoading = false;
  }
},
    async getallstudy() {
      const currentstudy = store.getters.getStudyIs;
        const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/getallstudy`,
           {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
        }
        );

       this.srtudylist = res.data;
       this.selectedStudy = currentstudy;
       let studyobj = this.srtudylist.find((eachstudy)=> eachstudy.studyId == this.selectedStudy ) 
       this.currentstudyname = studyobj.studyRef;
      } catch (err) {
        console.log("error in PerformanceBenchmark", err);
      }
    },

    buildComplexityCharts() {
      const labels = this.aactData.protocolComplexity.labels;

      this.complexityAACTSeries = this.aactData.protocolComplexity.values;
      this.complexityAACTOptions = {
        chart: {
          type: "donut",
          toolbar: { show: false },
        },
        labels,
        legend: {
          position: "bottom",
        },
        title: {
          text: "AACT",
          align: "center",
        },
      };

      this.complexityStudySeries = this.studyData.protocolComplexity.values;
      this.complexityStudyOptions = {
        chart: {
          type: "donut",
          toolbar: { show: false },
        },
        labels,
        legend: {
          position: "bottom",
        },
        title: {
          text: this.currentstudyname,
          align: "center",
        },
      };
    },
toSafeNumber(v) {
    var n = Number(v);
    return isFinite(n) ? n : 0;
  },

  async buildQtlComparison() {
    this.loadingQtl = true;

    try {
      const res = await axios.get(
        this.baseurl + "/aact-connection-py/aact/getqualitytolerancelimits" +
          "?therapeutic_area=" + encodeURIComponent(this.therapeuticArea) +
          "&phase=" + encodeURIComponent(this.studyPhase) +
          "&years_back=" + encodeURIComponent(this.timeRange) +
          "&study_id=" + encodeURIComponent(this.selectedStudy)
      );

      console.log("QtlComparison result =", res && res.data);
      var rows = {   "SAE rate": {     "aactBaseline": 1,     "currentStudy": 0   },   "Major Protocol Deviation Rate": {     "aactBaseline": 3,     "currentStudy": 0   },   "Enrollment rate": {     "aactBaseline": 145,     "currentStudy": 18   },   "Site Issue Outlier": {     "aactBaseline": 25,     "currentStudy": 0   } };

      var years = rows.map((r) => (r && r.year != null ? String(r.year) : ""));

      var aScreen = rows.map((r) => this.toSafeNumber(r && r.aact_screen_failure_breach));
      var aDrop   = rows.map((r) => this.toSafeNumber(r && r.aact_dropout_breach));
      var aAe     = rows.map((r) => this.toSafeNumber(r && r.aact_adverse_event_breach));

      var sScreen = rows.map((r) => this.toSafeNumber(r && r.study_screen_failure));
      var sDrop   = rows.map((r) => this.toSafeNumber(r && r.study_dropout));
      var sAe     = rows.map((r) => this.toSafeNumber(r && r.study_adverse_event));

      var studyName = this.currentstudyname ? this.currentstudyname : "Current Study";

      this.qtlSeries = [
        { name: "Screen Failure Breach", data: aScreen },
        { name: "Dropout Breach",        data: aDrop },
        { name: "AE Breach",             data: aAe },

        { name: studyName + " Screen Failure Breach", data: sScreen },
        { name: studyName + " Dropout Breach",        data: sDrop },
        { name: studyName + " AE Breach",             data: sAe },
      ];

      this.qtlOptions = Object.assign({}, this.qtlOptions, {
        xaxis: Object.assign({}, this.qtlOptions.xaxis, {
          categories: years,
          title: { text: "Year" },
        }),
        stroke: Object.assign({}, this.qtlOptions.stroke, {
          dashArray: [0, 0, 0, 4, 4, 4],
        }),
      });

    } catch (err) {
      console.error("error in QtlComparison", err);

      this.qtlSeries = [];
      this.qtlOptions = Object.assign({}, this.qtlOptions, {
        xaxis: Object.assign({}, this.qtlOptions.xaxis, { categories: [] }),
      });

    } finally {
      this.loadingQtl = false;
      console.log("QtlComparison finished");
    }
  },

    riskLevelClass(level) {
      if (level === "High") return "risk-high";
      if (level === "Medium") return "risk-medium";
      return "risk-low";
    },
  },
};